import { resetIntroPopups } from '../popups/popupsActions';
import { actionHideMeasurements } from '../scene/sceneActions';
import history from '../../services/history';
import { actionSetHideModal } from '../summary/summaryActions';
import { Thunk } from '../../generalTypes';

export const thunkResetApp: Thunk = () => dispatch => {
  dispatch(resetIntroPopups());
  dispatch(actionHideMeasurements({}));
  dispatch(actionSetHideModal());

  history.clear();
};
